import { EXPERIENCE } from "../../data/portfolio";
import { SECTION_INNER } from "./sectionStyles";

const Experience = () => {
  return (
    <section data-testid="experience-section" className="border-t border-ink-600">
      <div id="experience" className={SECTION_INNER}>
        <div className="grid grid-cols-12 gap-8 mb-12">
          <div className="col-span-12 lg:col-span-4">
            <div className="label-mono">[ 02 / Experience ]</div>
            <h2 className="mt-3 font-sans font-bold text-3xl sm:text-4xl leading-tight tracking-tight text-bone">
              Three years of<br />production weight.
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-7 lg:col-start-6">
            <p className="font-body text-lg text-bone-muted leading-relaxed">
              {EXPERIENCE.blurb}
            </p>
          </div>
        </div>

        <div
          data-testid="experience-card"
          className="border border-ink-600 bg-ink-900"
        >
          {/* Card header */}
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 p-6 sm:p-8 border-b border-ink-600">
            <div>
              <div className="label-mono">Current Role</div>
              <h3 className="mt-2 font-sans font-bold text-2xl sm:text-3xl text-bone tracking-tight">
                {EXPERIENCE.role}{" "}
                <span className="text-amber">@ {EXPERIENCE.company}</span>
              </h3>
              <div className="mt-1 font-mono text-sm text-bone-muted">
                {EXPERIENCE.location}
              </div>
            </div>
            <div className="font-mono text-sm text-bone-muted whitespace-nowrap">
              {EXPERIENCE.period}
            </div>
          </div>

          {/* Top impacts — quick scan for recruiters */}
          <div
            data-testid="experience-top-impacts"
            className="grid grid-cols-1 sm:grid-cols-3 gap-px bg-ink-600 border-b border-ink-600"
          >
            {EXPERIENCE.topImpacts.map((impact) => (
              <div key={impact.label} className="bg-ink-900 p-6 sm:p-8">
                <div className="font-sans font-bold text-3xl sm:text-4xl text-amber tracking-tighter">
                  {impact.value}
                </div>
                <div className="mt-2 font-body text-sm text-bone-muted leading-relaxed">
                  {impact.label}
                </div>
              </div>
            ))}
          </div>

          {/* Bullets list */}
          <ul className="divide-y divide-ink-600">
            {EXPERIENCE.bullets.map((b, i) => (
              <li
                key={i}
                data-testid={`experience-bullet-${i}`}
                className="grid grid-cols-12 gap-4 p-6 sm:p-8 hover:bg-ink-800/50 transition-colors"
              >
                <div className="col-span-12 sm:col-span-2">
                  <span className="inline-block label-mono border border-amber/40 px-2 py-1">
                    {b.tag}
                  </span>
                </div>
                <div className="col-span-12 sm:col-span-10">
                  <p className="font-body text-base sm:text-lg text-bone leading-relaxed">
                    {b.text}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Experience;
